import React, { useEffect, useState } from "react";
import "./style.scss";
import { getPredefineOptionsList } from "../../../AdminDashboard/AdminMentorAction/dependencies/action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import Button from "../../../AdminDashboard/Button";
import { Modal } from "react-bootstrap";
import MultiselectorComp from "../../../../../MultiselectorComp/MultiselectorComp";
import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  TableBody,
} from "@material-ui/core";
import clsx from "clsx";
import makeStyles from "@material-ui/core/styles/makeStyles";

const customStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "rgba(0,0,0,0.05)",
    // paddingLeft: "10px",
    minHeight: "45px",
    // borderRadius: "var(--curve10)",
    color: "#333",
    // border: "1px solid #bfc0c1",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#b499c7" : isFocused ? "#e4d7ee" : "white",
      color: isSelected ? "white" : "black",
      cursor: isDisabled ? "not-allowed" : "default",
    };
  },
};
const styles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: "rgba(0,0,0,0.2)",
      // backgroundColor:  isSelected &&isFocused ? "#b499c7" : "#b499c7",

      color: "#000",
    };
  },
};

const useStyles = makeStyles((theme) => ({
  tableRightBorder: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
    // whiteSpace: "nowrap",
  },
  smallWidth: {
    width: "300px",
    fontWeight: "bold",
    color: "#b499c7",
  },
  tableFont: {
    fontSize: "16px",
    fontFamily: "Montserrat",
  },
  tableContainer: {
    padding: "10px",
  },
  lessPadding: {
    padding: "3px 16px",
  },
}));

const StartupDashboard = (props) => {
  const classes = useStyles();

  return (
    <Modal
      size="lg"
      show={props.modalOpen}
      onHide={() => props.setModalOpen(false)}
      aria-labelledby="example-modal-sizes-title-lg"
      style={{ borderRadius: "7px" }}
    >
      <Modal.Header className="d-flex justify-content-center" closeButton>
        <Modal.Title className="modalHeading">
          MENTORSHIP REQUIREMENT
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <div className="d-flex justify-content-center">
          <div
            className="d-flex mt-2 startupstepsforms"
            style={{ maxWidth: "33rem", flexDirection: "column" }}
          >
            <h6 className="mt-2">Industry (Select 1 Industry) *</h6>
            <MultiselectorComp
              hideSelectedOptions={false}
              // styles={{ maxWidth: "10rem" }}
              styles={customStyles}
              placeholder="Select Industry"
              // styles={styles}
              value={{label: props?.modalData?.industry}}
              closeMenuOnSelect={true}
              isDisabled={true}
            />
            <h6 className="mt-2">
              Industry / Sector - Keywords (Industry/Function Keywords select up
              to 10) *{" "}
            </h6>
            <MultiselectorComp
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              styles={customStyles}
              placeholder="Industry/Sector Keywords"
              value={props?.modalData?.keys?.sub_industry.map(ele => ({label: ele}))}
              isDisabled={true}

            />
            <h6 className="mt-2">Function (Select 1 Function) *</h6>
            <MultiselectorComp
              closeMenuOnSelect={true}
              value={{label: props?.modalData?.function}}
              hideSelectedOptions={false}
              placeholder="Select Function"
              styles={customStyles}
              isDisabled={true}
            />
            <h6 className="mt-2">
              Function - Keywords (Industry/Function Keywords select up to 10) *
            </h6>

            <MultiselectorComp
              
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              placeholder="Function Keywords"
              styles={customStyles}
              value={props?.modalData?.keys?.sub_function.map(ele => ({label: ele}))}
              isDisabled={true}
            />

            <h6 className="mt-2">Current Stage of the Startup*</h6>
            <MultiselectorComp
              styles={styles}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              placeholder="Preferred stage of the startup"
              allowSelectAll={true}
              value={{label: props?.modalData?.stage}}
              isDisabled={true}
            />
            <div className="lastFilter">
              <h6 className="mt-2">State</h6>
              <MultiselectorComp
              styles={styles}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              placeholder="State"
              allowSelectAll={true}
              value={{label: props?.modalData?.state}}
              isDisabled={true}
            />
            </div>
          </div>
        </div> */}
        <Box className={classes.tableContainer}>
          <TableContainer component={Paper}>
            <Table>
              <TableBody>
                <TableRow>
                  {}
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont,
                      classes.smallWidth
                    )}
                  >
                    Industry
                  </TableCell>
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont
                    )}
                  >
                    {props?.modalData?.industry}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    rowSpan={props?.modalData?.keys?.sub_industry?.length + 1}
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont,
                      classes.smallWidth
                    )}
                  >
                    Industry/Sector - Keywords
                  </TableCell>
                </TableRow>
                {props?.modalData?.keys?.sub_industry?.map((ele) => (
                  <TableRow>
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont,
                        classes.lessPadding
                      )}
                    >
                      {ele}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont,
                      classes.smallWidth
                    )}
                  >
                    Function
                  </TableCell>
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont
                    )}
                  >
                    {props?.modalData?.function}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    rowSpan={props?.modalData?.keys?.sub_function?.length + 1}
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont,
                      classes.smallWidth
                    )}
                  >
                    Function - Keywords
                  </TableCell>
                </TableRow>
                {props?.modalData?.keys?.sub_function?.map((ele) => (
                  <TableRow>
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont,
                        classes.lessPadding
                      )}
                    >
                      {ele}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont,
                      classes.smallWidth
                    )}
                  >
                    Current Stage of the Startup
                  </TableCell>
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont
                    )}
                  >
                    {props?.modalData?.stage}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont,
                      classes.smallWidth
                    )}
                  >
                    State
                  </TableCell>
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont
                    )}
                  >
                    {props?.modalData?.state}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal.Body>
    </Modal>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
})(withRouter(StartupDashboard));
